export default __webpack_public_path__ + "static/media/Class-9-10-CBSE-English.b1733e1a.pdf";